import "../component_style/Profile.css"
import github from "../image/github.svg"
import linkedin from "../image/linkedin.svg"
import profile from "../image/profile.png"

import { useEffect } from "react"
import { BrowserRouter } from "react-router-dom"
import { HashLink as Link } from "react-router-hash-link"

export default function Profile (){
    const DownloadResume = () => {
        // using Java Script method to get PDF file
        fetch('fw18_0273_Nikhil_Walwatkar_ Resume.pdf').then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'Nikhil-Walwatkar-Resume.pdf';
                alink.click();
            })
        })
    }
    return(
        <div className="about_profile">
            <BrowserRouter>
            <div><h1 Style={"font-size: 2.5rem;"} ><spam Style="color:white" > Hello,</spam><br/><spam Style="color:white">  I'm </spam><samp Style="color:orange">Nikhil Walwatkar</samp><br/><spam Style="color:white" > MERN Developer</spam></h1>
            <div className="profile_socile" >

            <button className="resume_button" onClick={DownloadResume} ><a target="blank" href="https://drive.google.com/file/d/1DDev4bDLA1AmDuyomIR_0jPF5ZGvOnmx/view?usp=sharing" >Resume</a></button>
            <a href="https://www.linkedin.com/in/nikhil-walwatkar-898684183/" target="blank">
            <img className="profile_logo" src={linkedin}/>
            </a>
            <a href="https://github.com/Nikhil-81" target="blank">
                
                        <img className="profile_logo" src={github}/>
            </a>

            </div>
            </div>
          <img  src={profile} className="profile" />
            </BrowserRouter>
        </div>
    )
}